import { ExtendedVCenter } from 'vrlcm-gui-types';
import * as Constants from '../../../constants/action-constants';

export interface InitializeStepBinaryMapping {
  type: Constants.INITIALIZE_STEP_BINARY_MAPPING;
  payload: {
    dataCenterVmid: string;
    regionName: string;
    zoneName: string;
    vCenterName: string;
  };
}

export interface InitializeStepBinaryMappingSuccess {
  type: Constants.INITIALIZE_STEP_BINARY_MAPPING_SUCCESS;
  payload: {
    vCenter: ExtendedVCenter;
  };
}

export interface InitializeStepBinaryMappingFailed {
  type: Constants.INITIALIZE_STEP_BINARY_MAPPING_FAILED;
}

export type StepBinaryMappingAction =
  | InitializeStepBinaryMapping
  | InitializeStepBinaryMappingFailed
  | InitializeStepBinaryMappingSuccess;

export const initializeStepBinaryMapping = (
  dataCenterVmid: string,
  regionName: string,
  zoneName: string,
  vCenterName: string
): InitializeStepBinaryMapping => ({
  type: Constants.INITIALIZE_STEP_BINARY_MAPPING,
  payload: { dataCenterVmid, regionName, zoneName, vCenterName }
});

export const initializeStepBinaryMappingSuccess = (
  vCenter: ExtendedVCenter
): InitializeStepBinaryMappingSuccess => ({
  payload: { vCenter },
  type: Constants.INITIALIZE_STEP_BINARY_MAPPING_SUCCESS
});

export const initializeStepBinaryMappingFailed = (): InitializeStepBinaryMappingFailed => ({
  type: Constants.INITIALIZE_STEP_BINARY_MAPPING_FAILED
});
